import { GeneratedFieldsType } from 'modules/AppSettings/Plugin/components/PluginInstallation';

export const getFields: getFieldHelper = (generatedFields) => (key) => {
	return generatedFields && generatedFields[key] ? generatedFields[key] : key;
};

type getFieldHelper = (
	generatedFields: GeneratedFieldsType | null,
) => (key: keyof GeneratedFieldsType) => string;
